import { Link as RouterLink, useNavigate } from "react-router-dom";
import ChevronLeft from "./icons/chevron-left.svg";
import { Flex, Link, LinkProps } from "flux";

interface BackLinkProps extends LinkProps {
  children: React.ReactNode;
}

const BackLink: React.FC<BackLinkProps> = ({ children, to, ...restProps }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Link {...restProps} underline="hover" component={RouterLink} onClick={handleClick}>
      <Flex>
        <Flex mr="4px" alignItems="center">
          <ChevronLeft />
        </Flex>
        <span
          className="text-sm font-semibold truncate max-w-[245px] text-left text-orange-500"
          title={typeof children === "string" ? children : String(children)}
        >
          {children}
        </span>
      </Flex>
    </Link>
  );
};

export default BackLink;
